import styled from 'styled-components';
import type {
  HeaderStyledNavProps,
  HeaderStyledNavWrapperProps,
} from '../../interfaces/header-styled-components.interfaces';
import {
  generateMobileMenuMaxHeightCss,
  timeL,
  timeM,
  timeXL,
} from '../AudiHeader/AudiHeaderStyleUtils';

export const HeaderStyledNavWrapper = styled.div<HeaderStyledNavWrapperProps>`
  background-color: ${({ theme }): string =>
    theme.type === 'legacy' ? theme.colors.colorBaseWhite : theme.colors.colorBaseBlack};
  display: block;
  visibility: ${({ isOpen }): string => (isOpen ? 'visible' : 'hidden')};
  height: ${({ isOpen, showDealerSearch }): string =>
    isOpen ? generateMobileMenuMaxHeightCss(showDealerSearch, true) : '0'};
  left: 0;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: ${({ isOpen, isSubNavOpen }): string =>
    isOpen && !isSubNavOpen ? 'auto' : 'hidden'};
  position: absolute;
  top: var(--one-header-height);
  transition:
    height ${timeXL} ${({ theme }): string => theme.easing.easingDefault},
    visibility ${timeXL} ${timeXL} ${({ theme }): string => theme.easing.easingDefault};
  width: 100%;
  z-index: ${({ showSearch }): string => (showSearch ? '-1' : '1')};

  ${({ isSmallView, theme: { breakpoints } }) =>
    !isSmallView &&
    `@media screen and (min-width: ${breakpoints.l}px) {
      visibility: visible;
      height: var(--one-header-height);
      z-index: 1;
      //overflow: hidden;
      position: static;
      top: 0;
    }`}
`;

export const HeaderStyledNav = styled.nav<HeaderStyledNavProps>`
  opacity: ${({ isOpen }): string => (isOpen ? '1' : '0')};
  z-index: ${({ isOpen, isSmallView, isSubNavOpen }): string =>
    isOpen && isSmallView && isSubNavOpen ? '1' : '0'};
  position: ${({ isOpen, isSmallView }): string =>
    isOpen && isSmallView ? 'relative' : 'inherit'};
  padding: calc(var(--one-header-space-xxl) - var(--one-header-space-l) / 2)
    var(--one-header-side-spacing);
  transform: ${({ isOpen }): string => (isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  transform-origin: top;
  transition: ${({ isOpen, theme }): string =>
    isOpen
      ? `opacity ${theme.easing.easingDefault} ${timeL} ${timeM}, transform ${theme.easing.easingDefault} ${timeXL}`
      : `opacity ${theme.easing.easingDefault} ${timeM}, transform ${theme.easing.easingDefault} ${timeXL}`};

  ${({ isSmallView, theme: { breakpoints } }) =>
    !isSmallView &&
    `@media screen and (min-width: ${breakpoints.l}px) {
      display: flex;
      flex-wrap: nowrap;
      height: auto;
      opacity: 1;
      padding: 0;
      transform: none;
      transition: none;
    }`}
`;
